import React, { useEffect } from 'react';
import MarketingNav from './MarketingNav';
import MarketingFooter from './MarketingFooter';
import './marketing.css';

function MarketingLayout({ user, currentPage, onNavigate, onPrimaryCta, children }) {
  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const items = document.querySelectorAll('.marketing-reveal');
    if (!items.length) return undefined;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    items.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [currentPage]);

  // Pointer-tracked feature card glow (purely visual, no React state).
  useEffect(() => {
    const handler = (e) => {
      const card = e.target.closest('.marketing-feature-card');
      if (!card) return;
      const rect = card.getBoundingClientRect();
      const mx = ((e.clientX - rect.left) / rect.width) * 100;
      const my = ((e.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty('--mx', `${mx}%`);
      card.style.setProperty('--my', `${my}%`);
    };
    document.addEventListener('mousemove', handler);
    return () => document.removeEventListener('mousemove', handler);
  }, []);

  return (
    <div className="marketing-root">
      <div className="marketing-aurora" aria-hidden="true" />
      <div className="marketing-grid" aria-hidden="true" />
      <div className="marketing-shell">
        <MarketingNav
          user={user}
          currentPage={currentPage}
          onNavigate={onNavigate}
          onPrimaryCta={onPrimaryCta}
        />
        <main>{children}</main>
        <MarketingFooter onNavigate={onNavigate} />
      </div>
    </div>
  );
}

export default MarketingLayout;
